// Reusable SEO component. Wraps react-helmet-async to set page-specific
// meta, Open Graph, Twitter Card, and structured data.
import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://theintuitushub.com";
const DEFAULT_OG = `${SITE_URL}/og-default.png`;

export const SEO = ({
    title,
    description,
    path = "",
    image = DEFAULT_OG,
    type = "website",
    schema, // optional structured-data JSON object
}) => {
    const url = `${SITE_URL}${path}`;
    const fullTitle = title ? `${title} · The Intuitus Hub™` : "The Intuitus Hub™ · The HUMAN+ Framework";
    return (
        <Helmet>
            <title>{fullTitle}</title>
            {description && <meta name="description" content={description} />}
            <link rel="canonical" href={url} />

            {/* Open Graph */}
            <meta property="og:type" content={type} />
            <meta property="og:site_name" content="The Intuitus Hub" />
            <meta property="og:url" content={url} />
            <meta property="og:title" content={fullTitle} />
            {description && <meta property="og:description" content={description} />}
            <meta property="og:image" content={image} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            {description && <meta name="twitter:description" content={description} />}
            <meta name="twitter:image" content={image} />

            {schema && (
                <script type="application/ld+json">
                    {JSON.stringify(schema)}
                </script>
            )}
        </Helmet>
    );
};

export const ORG_SCHEMA = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "The Intuitus Hub",
    alternateName: "The Intuitus Hub™",
    url: SITE_URL,
    logo: `${SITE_URL}/logo512.png`,
    sameAs: [],
    description:
        "Research-informed consulting that helps organizations adopt AI while strengthening the human capabilities technology cannot replace.",
};

export const serviceSchema = ({ name, description, price }) => ({
    "@context": "https://schema.org",
    "@type": "Service",
    provider: {
        "@type": "Organization",
        name: "The Intuitus Hub",
        url: SITE_URL,
    },
    name,
    description,
    ...(price && {
        offers: {
            "@type": "Offer",
            priceCurrency: "USD",
            price: String(price),
        },
    }),
});

export default SEO;
